import * as React from "react";
import type { SVGProps } from "react";
const SvgWithdrawIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="withdraw_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M128 597.333A42.667 42.667 0 0 1 170.667 640v170.667a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V640a42.667 42.667 0 1 1 85.334 0v170.667a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V640A42.667 42.667 0 0 1 128 597.333zM268.501 371.5a42.667 42.667 0 0 0 60.331 0l140.501-140.502V640a42.667 42.667 0 1 0 85.334 0V230.997L695.168 371.5a42.667 42.667 0 1 0 60.33-60.331L542.166 97.835A42.496 42.496 0 0 0 512 85.333m-.427 0a42.539 42.539 0 0 0-29.738 12.502L268.5 311.168a42.667 42.667 0 0 0 0 60.33"
    />
  </svg>
);
export default SvgWithdrawIcon;
